<template>
  <div>
    <!-- <filed v-for="(item,key) in arr" :key="key" @titleTxt="title(value,key)"></filed> -->

    <div class="container">
      <Form :model="dealer" label-position="left" :label-width="80">
        <FormItem label="企业代码" v-if="getControl() == 1">
          <Input v-model="dealer.ClientCode" @click="SelectClientSwitch = !SelectClientSwitch" placeholder="企业代码"
            style="width: 100px"></Input>
        </FormItem>
        <FormItem label="代理编号">
          <Input v-model="dealer.Code" placeholder="代理编号" style="width: 150px"></Input>
        </FormItem>
        <FormItem label="代理名称">
          <Input v-model="dealer.Name" placeholder="代理名称"></Input>
        </FormItem>
        <FormItem label="展示厂商">
          <i-switch v-model="dealer.ShowPdvendor" size="large">
            <template #open>
              <span>是</span>
            </template>
            <template #close>
              <span>否</span>
            </template>
          </i-switch>
        </FormItem>
        <FormItem label="生产厂商">
          <Input v-model="dealer.pdvendor" placeholder="生产厂商"></Input>
        </FormItem>
        <FormItem label="展示电话">
          <i-switch v-model="dealer.ShowPhone" size="large">
            <template #open>
              <span>是</span>
            </template>
            <template #close>
              <span>否</span>
            </template>
          </i-switch>
        </FormItem>
        <FormItem label="联系电话">
          <Input v-model="dealer.Phone" placeholder="联系电话"></Input>
        </FormItem>
        <FormItem label="修改密码">
          <i-switch v-model="dealer.PasswordSwitch" size="large">
            <template #open>
              <span>是</span>
            </template>
            <template #close>
              <span>否</span>
            </template>
          </i-switch>
        </FormItem>
        <FormItem label="登陆密码" v-if="dealer.PasswordSwitch">
          <Input v-model="dealer.Password" placeholder="登陆密码"></Input>
        </FormItem>
        <FormItem label="销售地区">
          <Row>
            <Col span="12">
            <City v-model="dealer.AreaCode" show-suffix />
            </Col>
          </Row>
          <!-- <Input
            v-model="formValidate.DateAddress"
            type="textarea"
            placeholder="详细地址"
          ></Input> -->
        </FormItem>
        <FormItem label="修改背景">
          <input id="FileInput" class="FileInput" type="file" @input="upload('input', $event.target.files[0])" />
        </FormItem>
        <FormItem label="备注说明">
          <Input v-model="remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请备注说明..."></Input>
        </FormItem>
      </Form>
    </div>
    <div class="btn">
      <Button @click="echo()" type="success" style="width: 100px; height: 40px">保&nbsp;存</Button>
    </div>

    <!-- 选择企业 -->
    <transition name="fade">
      <SelectClient v-if="SelectClientSwitch" @Value="SelectClientVal" @close="SelectClientClose"></SelectClient>
    </transition>
  </div>
</template>

<script>
import FiledUpload from "@/views/FiledUpload";
import { UpdataDealerList, uploadImg } from "@/api/index";
import SelectClient from "@/views/selectClient";
import { mapState } from "vuex";
export default {
  props: ["datas"],
  data() {
    return {
      id: '',
      title1: "",
      dealer: {
        ClientCode: "",
        PasswordSwitch: "",
        Name: "",
        Code: "",
        Phone: "",
        Password: "",
        AreaCode: "",
        ShowPhone: '',
        pdvendor:'',
        ShowPdvendor:'',
      },
      remark: "",
      SelectClientSwitch: false,
    };
  },
  components: {
    SelectClient,
    FiledUpload,
  },
  watch: {
    datas(newV, oldV) {
      if (newV.showphone == '1') {
        this.dealer.ShowPhone = true
      }else{
        this.dealer.ShowPhone = false
      }
      this.dealer.ClientCode = newV.clientCode
      this.remark = newV.remark
      this.dealer.Name = newV.u_name
      this.dealer.Code = newV.u_code
      this.dealer.Phone = newV.u_phone
      this.dealer.AreaCode = newV.u_area
      this.dealer.bgImg = newV.bgimg
      this.dealer.pdvendor = newV.pdvendor
      this.id = newV.id
      this.dealer.ShowPdvendor = newV.showpdvendor
    }
  },
  computed: mapState({
    control: (state) => state.control,
  }),
  created() {
    //   console.log('1-'+this.control);
  },
  methods: {
    upload(a, b) {
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      let param = new FormData(); // 创建form对象
      param.append("file", b); // 通过append向form对象添加数据
      uploadImg(param, config).then((res) => {
        this.dealer.bgImg = res.data
      });
    },
    getControl() {
      return this.control;
    },
    // 添加图片
    addImgArr(value) {
      this.imgObj.imgarr.push(value);
    },
    SelectClientClose() {
      this.SelectClientSwitch = false;
    },
    SelectClientVal(value) {
      this.dealer.ClientCode = value;
      this.SelectClientSwitch = false;
    },
    propsTitleVal(key) {
      return this.arr[key].title;
    },
    propsMessageVal(key) {
      return this.arr[key].message;
    },
    add() {
      this.arr.push({ title: "", type: "text", message: "" });
    },
    // 完成按钮
    echo() {
      UpdataDealerList({
        id: this.id,
        u_name: this.dealer.Name,
        u_phone: this.dealer.Phone,
        u_code: this.dealer.Code,
        u_area: this.dealer.AreaCode,
        remark: this.remark,
        password: this.dealer.Password,
        bgimg: this.dealer.bgImg,
        showphone:this.dealer.ShowPhone,
        pdvendor:this.dealer.pdvendor,
        showpdvendor:this.dealer.ShowPdvendor
      }).then((res) => {
        if (res) {
          const arr = {
            title: this.title1,
            arr: JSON.stringify(this.arr),
          };
          this.$emit("results", arr);
          this.$Notice.success({ title: "修改成功" });
        } else {
          this.$Notice.error({ title: "修改失败" });
        }
      });
    },
    title(event, key) {
      this.arr[key].title = event;
    },
    message(event, key) {
      this.arr[key].message = event;
    },
    jian(key) {
      // console.log(key);
      this.arr[key] = {};
      this.arr.splice(key, 1);
    },
  },
};
</script>

<style scoped >
.container {
  max-height: calc(100% - 100px);
}

.containers {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;
}

.line {
  line-height: 32px;
}

.jian {
  margin-left: 10px;
  height: 32px;
  width: 32px;
  cursor: pointer;
}

.jian_img {
  width: 100%;
}
</style>
